import { render } from "./submitForm.vue?vue&type=template&id=4c7b6e16"
import script from "./submitForm.vue?vue&type=script&lang=js"
export * from "./submitForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/nodano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__